export default "/packs/images/walkietalkie@2x~bbe55567c92240cfd75d308421790039.png";